<div class="flex flex-col  md:min-w-160 max-h-screen -m-6 dms-modal">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="modal_title">Search Chats</div>
        <button mat-icon-button (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto px-6 py-3 sm:px-8 sm:py-4 overflow-y-auto">
        <!-- Search Input -->
        <div class="flex items-center gap-3 border-b border-divider pb-3">
            <mat-icon svgIcon="heroicons_outline:magnifying-glass" class="opacity-70"></mat-icon>
            <input #searchInput type="text" [(ngModel)]="query" (input)="onSearchChange()" placeholder="Search chats..."
                class="flex-1 bg-transparent outline-none text-lg placeholder:text-muted-foreground" />
            <button mat-icon-button (click)="clear()" matTooltip="Close">
                <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
        </div>

        <!-- Search Results -->
        <div *ngIf="query.length > 0 && !loading" class="mt-3 max-h-[300px] overflow-y-auto">
            <div *ngFor="let chat of chats; let i = index" (click)="selectChat(chat)"
                class="px-3 py-2 rounded-lg cursor-pointer hover:bg-hover transition-colors">
                <div class="font-medium">{{ chat.sessionName }}</div>
                <!-- <div class="text-sm text-muted-foreground truncate">{{ chat.lastMessage }}</div> -->
            </div>

            <div *ngIf="chats.length === 0" class="text-center text-md text-muted-foreground mt-4 ">
                No chats found.
            </div>

        </div>

        <div *ngIf="loading" class="flex justify-center items-center mt-5">
            <mat-progress-spinner [diameter]="40" mode="indeterminate"></mat-progress-spinner>
        </div>
    </div>

</div>